import { GridColumnType } from "../../../data/gridColumnType";


export const CriteriaApprovalConfig = {
  columns: [
    {
      name: "Channel",
      fieldName: "channelName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Criteria Name",
      fieldName: "criteriaName",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      customWrapper: [
          {
              name: "VIEW",
              label: "View",
          },
          // {
          //     name: "ACTIVATE",
          //     label: "Activate",
          // },
          {
              name: "DEACTIVATE",
              label: "Deactivate",
          },
      ],
      defaultAction: {
          allowEdit: false,
          allowDelete: false,
      },
  },
  ],
};
